export default __webpack_public_path__ + "static/media/iv-logo-white.aa4bf041.svg";